import * as CheckoutAPIActions from '../actions/APIActions/CheckoutAPIActions';
import Track from '../utils/tracking';

const getAlipayPlusWalletDetails = (localeCode, dispatch) => dispatch(CheckoutAPIActions
  .getPaymentSessionDetails('alipayPlus', {paymentMethod: 'ALIPAY_PLUS'}))
  .then((sessionResponse) => {
    if (!sessionResponse?.msg?.logos || sessionResponse.msg.logos.length < 1) {
      return null;
    }
      
    const getLogo = logos => ({
      url: logos.find(icon => icon.logoName === 'Alipay+')?.logoUrl || '',
      name: 'alipay_plus',
      type: 'alipay_plus',
    });
      
    const getPromoText = (promoNames) => {
      const promosArray = [];
      
      if (!promoNames || promoNames.length < 1) {
        return [];
      }
      
      promoNames.forEach((promo) => {
        if (promo[localeCode]) {
          promosArray.push(promo[localeCode]);
        } else if (Object.keys(promo)[0]?.includes('en')) {
          promosArray.push(Object.values(promo)[0]);
        }
      });
        
      return promosArray;
    };
      
    return ({
      icon: {
        ...getLogo(sessionResponse.msg.logos),
      },
      promos: {
        text: getPromoText(sessionResponse.msg.promoNames),
      },
    });
  })
  .catch((error) => {
    Track.track(error);
    return null;
  });

export default getAlipayPlusWalletDetails;
